<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
        <h5 v-bind:style="{ color: 'white' }">FICHA DE LA BICI</h5>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana"
        >mdi-close-circle</v-icon
      >
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-8" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field
              v-model="modelBici.numero"
              outlined
              label="Numero"
              dense
              :dark="dark"
              autocomplete="off"
            ></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-col>
            <v-select
            class="mr-5"
            :items="['S', 'M', 'L', 'XL', 'MS', 'MM', 'ML']"
            label="Seleccione la talla"
            dense
            :dark="dark"
            outlined
            v-model="modelBici.talla"
          ></v-select>
          </v-col>

          <v-col>

           <v-select
           class="ml-5"
            :items="['BIANCHI', 'CUBE', 'HAIBIKE', 'MUSCULAR']"
            label="Seleccione la marca"
            dense
            :dark="dark"
            outlined
            v-model="modelBici.marca"
          ></v-select>
          </v-col>
            
          </v-row>

        

          <v-row dense class="mx-4">
            <v-textarea
              outlined
              v-model="modelBici.observaciones"
              :dark="dark"
              label="Observaciones"
            ></v-textarea>
          </v-row>

          <v-row dense class="mx-4">
            <v-switch
              v-model="ordenarInicio"
              :true-value="1"
              :false-value="0"
              :dark="dark"
              inset
              label="Ubicar al inicio de todas"
            ></v-switch>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mx-4 mb-2">
        <v-spacer></v-spacer>
        <v-chip
          class="mr-1 px-10"
          label
          :color="colorEBikeAccent1"
          text-color="white"
          link
          @click="_guardarBici"
        >
          <h5 v-if="loading" v-bind:style="{ color: 'white' }">
                Guardando...
              </h5>
              <h5 v-else v-bind:style="{ color: 'white' }">Guardar</h5>
        </v-chip>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "BiciFormulario",
  components: {},
  data: () => ({
    loading: false,
    ordenarInicio: 0,
  }),

  props: {
    modelBici: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    }
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",


      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },

  watch: {
    modelBici: {
      immediate: true,
      handler() {
        this._sincronizarOrdenarInicio();
      },
    },
  },

  mounted() {
    this._sincronizarOrdenarInicio();
  },

  methods: {
    ...mapActions("bicis", ["getBicis", "crearBici", "updateBici"]),

    

    

   

    _cerrarVentana() {
      this.$emit("cerrarFormularioBici");
    },

    _sincronizarOrdenarInicio() {
      const ordenarInicio =
        this.modelBici && Number(this.modelBici.ordenar_inicio) === 1 ? 1 : 0;
      this.ordenarInicio = ordenarInicio;
      if (
        this.modelBici &&
        typeof this.modelBici.ordenar_inicio === "undefined"
      ) {
        this.$set(this.modelBici, "ordenar_inicio", ordenarInicio);
      }
    },

    async _guardarBici() {
      this.loading = true;
      const modelToSend = {
        ...this.modelBici,
        ordenar_inicio: Number(this.ordenarInicio) === 1 ? 1 : 0,
      };
      this.$set(this.modelBici, "ordenar_inicio", modelToSend.ordenar_inicio);
      if (this.accion == "crear") {
       
        var res = await this.crearBici([
          this.access_token,
          modelToSend,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getBicis([this.access_token, params, true]);
        
      } else if (this.accion == "editar") {
       
        var res = await this.updateBici([
          this.access_token,
          modelToSend,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },
  },
};
</script>
